import React from "react";
import "./../../styles/businessnavbar.scss";

function SalesNavBar(){
    return(
        <div className ="main-header">
            <a className ="menu-link-main" href="#">All Apps</a>
            <div className ="header-menu">
                <a className ="main-header-link" href="#">Summary</a>
                <a className ="main-header-link is-active" href="#">On Hand</a>
                <a className ="main-header-link" href="#">Future Sales</a>
                <a className ="main-header-link" href="#">Inventory to Market</a>
            </div>
        </div>
    );
}

export {SalesNavBar};